import { sendPost } from '../http.js'
const api = {
    'exchangeListAPI': {
        url: '/exchange/index'
    },
    'exchangeAddAPI': {
        url: '/exchange/add'
    },
    'exchangeStatusAPI': {
        url: '/exchange/status'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = (params) => {
        return sendPost(api[key].url, params)
    }
}
export default requestFunObj
